import React, { useEffect, useMemo, useState } from "react";
import { ChangeLastCdrClicked, fetchPreviousMessages } from "../../actions";
import { previusMessagesService } from "./utils/PreviusMessagesService";
import { useDispatch, useSelector } from "react-redux";
import { getMessagesRecursiveInBantchReverseMode } from "../../actions/websocket";
import { Box, CircularProgress } from "@mui/material";

import { ReactComponent as MESSAGEICON } from "../../build/images/attendanceIcons/message-search.svg";

const PreviousMessages = ({ cdr, number, mediaId }) => {
  const dispatch = useDispatch();
  const ContactId = useSelector((state) => state.atendimento);
  const informationusers = useSelector((state) => state.informationusers);
  const [isLoading, setIsLoading] = useState(false);
  const [allCdrs, setAllCdrs] = useState([]);
  const isFecthingPreviousMessages = useMemo(() => {
    const hasContactId =
      Boolean(ContactId) && Boolean(ContactId.lastCdrClicked);
    if (!hasContactId) return false;
    return ContactId.lastCdrClicked.isLoading;
  }, [ContactId]);
  const currentCdr = useMemo(() => {
    const hasContactId = Boolean(ContactId);
    if (!hasContactId) {
      return cdr;
    }
    const hasLastCdrClicked =
      Boolean(ContactId.lastCdrClicked) &&
      Boolean(ContactId.lastCdrClicked.cdr);
    if (!hasLastCdrClicked) {
      return parseInt(ContactId.idatendimento);
    }
    return parseInt(ContactId.lastCdrClicked.cdr);
  }, [ContactId]);
  const nextCdr = useMemo(() => {
    if (allCdrs.length === 0) return null;
    const indexOfCurrentCdr = allCdrs.findIndex(
      (cdr) => parseInt(cdr.id) === parseInt(currentCdr)
    );
    if (indexOfCurrentCdr === -1) return parseInt(allCdrs[0].id);
    if (allCdrs.length - 1 <= indexOfCurrentCdr) return null;

    return parseInt(allCdrs[indexOfCurrentCdr + 1].id);
  }, [allCdrs, currentCdr]);

  useEffect(() => {
    const getCdrs = async () => {
      setIsLoading(true);
      if (previusMessagesService.hasThisData(cdr)) {
        setIsLoading(false);
        setAllCdrs(previusMessagesService.getLoadedCdrs(cdr));
      }
      const response = await fetchPreviousMessages(number, mediaId);
      const hasResponse = Boolean(response) && response.status === 200;
      const hasData =
        hasResponse && Boolean(response.data) && Boolean(response.data.data);
      if (hasData) {
        previusMessagesService.setLoadedCdrs(cdr, response.data.data);
        setAllCdrs(response.data.data);
      } else {
        setAllCdrs([]);
      }
      setIsLoading(false);
    };

    getCdrs();
  }, [cdr, number, mediaId]);

  const handleClick = () => {
    dispatch(
      ChangeLastCdrClicked(cdr, {
        cdr: nextCdr,
        isLoading: true,
        isError: false,
      })
    );
    getMessagesRecursiveInBantchReverseMode(
      cdr,
      nextCdr,
      informationusers,
      dispatch
    );
  };
  if (isLoading || isFecthingPreviousMessages) {
    return (
      <Box sx={{ display: "flex" }}>
        <CircularProgress disableShrink size={"30px"} />
      </Box>
    );
  }

  return (
    <div>
      {nextCdr !== null && (
        <button
          style={{
            backgroundColor: "#455cc7",
            color: "#ffffff",
            fontFamily: "'Inter', sans-serif",
            padding: "5px 10px",
            borderRadius: "80px",
            cursor: "pointer",
            border: "none",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "113%",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
          onClick={handleClick}
        >
          <MESSAGEICON />
          <span>Carregar conversa anterior</span>
        </button>
      )}
    </div>
  );
};

export default PreviousMessages;
